import { RiCloseLine } from '@remixicon/react'
import AppModalGeneral from '../../../../components/atoms/AppModalGeneral/AppModalGeneral'

interface ConfirmDeleteModalProps {
    isOpen: boolean
    title: string
    itemName: string
    message?: string
    onConfirm: () => void
    onCancel: () => void
}

export default function ConfirmDeleteModal({
    isOpen,
    title,
    itemName,
    message = 'Esta acción es irreversible y no se podrá deshacer.',
    onConfirm,
    onCancel,
}: ConfirmDeleteModalProps) {
    return (
        <AppModalGeneral isOpen={isOpen}>
            <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 z-10">
                {/* Close button */}
                <button
                    onClick={onCancel}
                    className="absolute top-4 right-4 text-[#64748B] hover:text-[#0F172A] transition-colors cursor-pointer"
                >
                    <RiCloseLine className="w-6 h-6" />
                </button>

                {/* Title */}
                <h2 className="text-xl font-semibold text-[#0F172A] pb-2">
                    {title}
                </h2>
                <div className="border-b absolute w-full left-0 top-16 mb"></div>
                {/* Message */}
                <p className="text-[#0F172A] mb-6 mt-6">
                    ¿Estas seguro que quieres desvincular{' '}
                    <span className="font-semibold">{itemName}</span>?
                    <br />
                    {message}
                </p>

                {/* Buttons */}
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-6 py-2 text-[#0F172A] font-medium hover:bg-[#F1F5F9] rounded-lg transition-colors cursor-pointer"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-[18px] py-3 bg-[#B91C1C] text-white font-medium rounded-lg hover:bg-[#991B1B] transition-colors cursor-pointer"
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </AppModalGeneral>
    )
}
